import posthog from "posthog-js";

export const initPostHog = () => {
  posthog.init(import.meta.env.REACT_APP_POSTHOG_KEY || "", {
    api_host:
      import.meta.env.REACT_APP_POSTHOG_HOST || "https://app.posthog.com",
    loaded: (posthog) => {
      if (import.meta.env.REACT_APP_MODE === "development")
        posthog.opt_out_capturing();
    },
  });
};
